<template>
  <v-container>
    <v-fade-transition>
      <section
        v-if="currentItem != null && currentItem.type == 'model_instructions'"
      >
        <p>
          You will be presented with a recording of a speaker auditioning to be
          a podcast host. After listening once, proceed to answer some questions
          about what you heard in the story. Press 'Next' to proceed.
        </p>
        <p v-if="prime == 1" class="font-weight-bold">
          Recent studies have found that men are more likely to use uptalk, a
          speaking style with a rising tone at the end of declarative sentences,
          than speakers of other genders.
        </p>
        <p v-else-if="prime == 2" class="font-weight-bold">
          Recent studies have found that women are more likely to use uptalk, a
          speaking style with a rising tone at the end of declarative sentences,
          than speakers of other genders.
        </p>
        <p v-else-if="prime == 3" class="font-weight-bold">
          Recent studies have found that speakers of all genders are equally
          likely to use uptalk, which is a speaking style with a rising tone at
          the end of declarative sentences.
        </p>
      </section>
      <section
        v-if="currentItem != null && currentItem.type == 'cloze_instructions'"
      >
        <v-col>
          <v-row justify="center">
            <p>
              Please fill in the missing content in the following sentences.
            </p>
          </v-row>
        </v-col>
      </section>
      <section
        v-if="currentItem != null && currentItem.type == 'trial_instructions'"
      >
        <p>
          You will now be presented with sentences you may have heard previously
          in the passage. While the content in each sentence will be the exact
          same from the passage before, the intonation pattern that the speaker
          uses may be different than before. In this task, intonation refers to
          the tone and pitch a speaker uses through a sentence. After you listen
          to each sentence, indicate whether the intonation is
          <strong>different</strong> from the version you heard in the original
          passage or the <strong>same</strong> as the version you heard in the
          original passage. If this version has the same exact intonation
          pattern as the version you heard in the original passage, press
          <strong>'SAME'</strong> to indicate that the version is the same as
          before. If this version has a different intonation pattern than the
          version you heard in the original passage, press
          <strong>'DIFFERENT'</strong>
          to indicate that the version is different from the one heard
          previously. Please respond as quickly and as accurately as possible.
        </p>
        <p v-if="prime == 1">
          Recent studies have found that men are more likely to use uptalk, a
          speaking style with a rising tone at the end of declarative sentences,
          than speakers of other genders.
        </p>
        <p v-else-if="prime == 2">
          Recent studies have found that women are more likely to use uptalk, a
          speaking style with a rising tone at the end of declarative sentences,
          than speakers of other genders.
        </p>
        <p v-else-if="prime == 3">
          Recent studies have found that speakers of all genders are equally
          likely to use uptalk, which is a speaking style with a rising tone at
          the end of declarative sentences.
        </p>
      </section>
      <section v-if="currentItem != null && currentItem.type == 'speaker_eval'">
        <v-col>
          <v-row justify="center">
            <p>
              Please answer the questions below. You may play the speaker's
              recording below while responding.
            </p>
          </v-row>
          <v-row justify="center">
            <v-btn
              color="primary"
              @click="play(currentItem.audio)"
              class="mb-4"
              x-large
              :disabled="listens >= 1 || isPlaying"
              >Play <v-icon>play_circle_filled</v-icon></v-btn
            >
          </v-row>
          <SpeakerEval
            class="mt-4"
            v-model="speakerEvalFormValid"
            ref="speakerEvalComp"
          ></SpeakerEval>
        </v-col>
      </section>
      <section v-if="currentItem != null && currentItem.type == 'listen'">
        <v-col>
          <v-row justify="center">
            <h2>Please Listen</h2>
          </v-row>
          <v-row justify="center">
            <v-btn
              color="primary"
              x-large
              @click="play(currentItem.audio)"
              :disabled="listens >= 1 || isPlaying"
              >Play <v-icon>play_circle_filled</v-icon></v-btn
            >
          </v-row>
        </v-col>
      </section>
      <section v-if="currentItem != null && currentItem.type == 'cloze_block'">
        <p>{{ currentItem.prompt }}</p>
        <v-text-field
          filled
          autofocus
          placeholder="Type your answer here"
          v-model="cloze_input"
          @keyup="clozeKeyPress"
        ></v-text-field>
      </section>
      <section
        v-if="currentItem != null && currentItem.type == 'same_different'"
      >
        <p>
          Please listen to this audio recording. If this version has the same
          exact intonation pattern as the version you heard in the original
          passage, press 'SAME' to indicate that the version is the same as
          before. If this version has a different intonation pattern than the
          version you heard in the original passage, press 'DIFFERENT' to
          indicate that the version is different from the one you heard
          previously.
        </p>
        <!-- <p v-if="prime == 1">
          Recent studies have found that men are more likely to use uptalk, a
          speaking style with a rising tone at the end of declarative sentences,
          than speakers of other gender.
        </p>
        <p v-else-if="prime == 2">
          Recent studies have found that women are more likely to use uptalk, a
          speaking style with a rising tone at the end of declarative sentences,
          than speakers of other genders.
        </p>
        <p v-else-if="prime == 3">
          Recent studies have found that speakers of all genders are equally
          likely to use uptalk, which is a speaking style with a rising tone at
          the end of declarative sentences.
        </p> -->
        <v-col>
          <v-row justify="center">
            <v-btn
              x-large
              @click="play(currentItem.audio, true)"
              color="primary"
              :disabled="listens >= 1 || isPlaying"
              >Play <v-icon>play_circle_filled</v-icon></v-btn
            >
          </v-row>
          <v-row justify="center" class="mt-10">
            <v-btn-toggle
              v-model="same_diff_selection"
              color="indigo accent-4"
              @change="sameDifferentChanged"
            >
              <v-btn style="min-width: 180px" x-large :disabled="listens <= 0">
                Same
              </v-btn>
              <v-btn style="min-width: 180px" x-large :disabled="listens <= 0">
                Different
              </v-btn>
            </v-btn-toggle>
          </v-row>
        </v-col>
      </section>
    </v-fade-transition>

    <v-col class="mt-5" v-if="currentItem != null">
      <v-row justify="center">
        <v-btn @click="next" :disabled="!nextEnabled || isPlaying">
          Next
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-row>
      <v-row justify="center">
        <p v-if="progress != null">
          {{ progress }}
        </p>
      </v-row>
    </v-col>
  </v-container>
</template>

<script>
import SpeakerEval from "@/components/SpeakerEval.vue";
//import useShuffle from "@/composables/useShuffle";
import { computed, onMounted, ref } from "@vue/composition-api";
import { Howl, Howler } from "howler";
import Vue from "vue";
import router from "@/router";
import store from "@/store";
import {
  ref as fbRef,
  getDatabase,
  push,
  serverTimestamp,
} from "firebase/database";
export default {
  components: {
    SpeakerEval,
  },
  setup() {
    onMounted(() => {
      //getLists(listName);
      index.value = 0;
      listens.value = 0;
      fullList.value = store.state.list;
      currentItem.value = fullList.value[index.value];
    });

    const listens = ref(0);
    const index = ref(0);
    const fullList = ref([]);
    const prime = computed(() => store.state.prime);
    const currentItem = ref(null);

    const next = () => {
      saveToFirebase();

      cloze_input.value = null;
      same_diff_selection.value = null;
      currentItem.value = null;
      listens.value = 0;
      index.value += 1;
      if (index.value >= fullList.value.length) {
        console.log("reached end!!!");
        index.value -= 1;
        store.commit("setLocked", false);
        router.push("/attitudeSurvey");
      } else {
        setTimeout(() => {
          currentItem.value = fullList.value[index.value];
        }, 125);
      }
    };

    const isPlaying = ref(false);
    const rtStart = ref(null);
    const rtEnd = ref(null);
    const play = (soundFile, captureRT = false) => {
      Howler.stop();
      isPlaying.value = true;
      console.log(soundFile);
      var sound = new Howl({
        src: ["audio/" + store.state.listname + "/" + soundFile],
        //src: [soundFile],
        volume: 1,
        onload: () => {
          sound.play();
        },
        onloaderror: () => {
          listens.value = 0;
          isPlaying.value = false;
          Vue.prototype.$dialog.error({
            text: "Could not load sound file. Please try again.",
            title: "Error",
          });
        },
        onend: () => {
          listens.value += 1;
          isPlaying.value = false;
          if (captureRT == true) {
            rtStart.value = performance.now();
          } else {
            rtStart.value = null;
          }
        },
      });
    };

    const sameDifferentChanged = () => {
      rtEnd.value = performance.now();
    };

    const progress = computed(() => {
      if (fullList.value != null) {
        return index.value + 1 + " of " + fullList.value.length;
      }
    });

    const nextEnabled = computed(() => {
      if (
        currentItem.value.type == "model_instructions" ||
        currentItem.value.type == "cloze_instructions" ||
        currentItem.value.type == "trial_instructions"
      ) {
        return true;
      } else if (currentItem.value.type == "listen") {
        if (listens.value <= 0) {
          return false;
        } else {
          return true;
        }
      } else if (currentItem.value.type == "cloze_block") {
        if (cloze_input.value == null || cloze_input.value == "") {
          return false;
        } else {
          return true;
        }
      } else if (currentItem.value.type == "same_different") {
        if (same_diff_selection.value == null) {
          return false;
        } else {
          return true;
        }
      } else if (currentItem.value.type == "speaker_eval") {
        return speakerEvalFormValid.value;
      }
    });

    const clozeKeyPress = (event) => {
      if (nextEnabled.value == true && event.keyCode == 13) {
        next();
      }
    };

    const same_diff_selection = ref(null);
    const cloze_input = ref(null);
    const speakerEvalFormValid = ref(null);
    const speakerEvalComp = ref(null);

    function saveToFirebase() {
      let dataToSave;
      if (currentItem.value.type == "cloze_block") {
        dataToSave = { ...currentItem.value };
        dataToSave.response = cloze_input.value;
      } else if (currentItem.value.type == "same_different") {
        //same_diff_selection.value, 0=same, 1=different
        dataToSave = { ...currentItem.value };
        if (same_diff_selection.value == 0) {
          dataToSave.response = "same";
        } else {
          dataToSave.response = "different";
        }
        dataToSave.reactionTime = rtEnd.value - rtStart.value;
      } else if (currentItem.value.type == "speaker_eval") {
        dataToSave = { ...currentItem.value };
        dataToSave.response = {};
        for (let rq of speakerEvalComp.value.ratingQuestions) {
          dataToSave.response[rq.key] = rq.response;
        }
        dataToSave.response.age = speakerEvalComp.value.age;
        dataToSave.response.gender = speakerEvalComp.value.gender;
        dataToSave.response.genderOther = speakerEvalComp.value.genderOther;
        dataToSave.response.feminine = speakerEvalComp.value.feminine;
        dataToSave.response.masculine = speakerEvalComp.value.masculine;
        dataToSave.response.race = speakerEvalComp.value.race;
        dataToSave.response.raceOther = speakerEvalComp.value.raceOther;
        dataToSave.timestamp = serverTimestamp();
      }

      if (dataToSave != null) {
        dataToSave.listname = store.state.listname;
        dataToSave.prime = store.state.prime;
        push(
          fbRef(
            getDatabase(),
            store.state.experimentName + "/data/" + store.state.pid
          ),
          dataToSave
        );
      }
    }

    return {
      next,
      currentItem,
      progress,
      sameDifferentChanged,
      same_diff_selection,
      play,
      nextEnabled,
      clozeKeyPress,
      listens,
      isPlaying,
      cloze_input,
      speakerEvalFormValid,
      speakerEvalComp,
      prime,
    };
  },
};
</script>
